import { render, staticRenderFns } from "./FreightHeader.vue?vue&type=template&id=b831aeec&scoped=true&"
import script from "./FreightHeader.vue?vue&type=script&lang=js&"
export * from "./FreightHeader.vue?vue&type=script&lang=js&"
import style0 from "./FreightHeader.vue?vue&type=style&index=0&id=b831aeec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b831aeec",
  null
  
)

export default component.exports